const toNumber = (value, fallback = 0) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
};

export const normalizeCouponStatus = (status) =>
  String(status || "").trim().toLowerCase();

export const isCouponUsed = (claim) => {
  if (!claim || typeof claim !== "object") return false;
  const status = normalizeCouponStatus(claim.status);
  return Boolean(
    status === "used" ||
      status === "redeemed" ||
      status === "consumed" ||
      claim.usedAt ||
      String(claim.usedForEventId || "").trim()
  );
};

const claimUpdatedAt = (claim) =>
  Math.max(
    toNumber(claim?.updatedAt, 0),
    toNumber(claim?.usedAt, 0),
    toNumber(claim?.lastUsedAt, 0),
    toNumber(claim?.claimedAt, 0),
    toNumber(claim?.offeredAt, 0)
  );

export const mergeClaimedRewards = (...rewardMaps) => {
  const out = {};

  rewardMaps.forEach((rewardMap) => {
    if (!rewardMap || typeof rewardMap !== "object" || Array.isArray(rewardMap)) {
      return;
    }

    Object.entries(rewardMap).forEach(([claimId, claim]) => {
      if (!claimId || !claim || typeof claim !== "object") return;

      const current = out[claimId] || {};
      const preferIncoming = claimUpdatedAt(claim) >= claimUpdatedAt(current);
      const merged = preferIncoming
        ? { ...current, ...claim }
        : { ...claim, ...current };

      if (isCouponUsed(current) || isCouponUsed(claim)) {
        const usedAt = Math.max(
          toNumber(current.usedAt, 0),
          toNumber(claim.usedAt, 0),
          toNumber(current.lastUsedAt, 0),
          toNumber(claim.lastUsedAt, 0)
        );
        merged.status = "used";
        if (usedAt > 0) merged.usedAt = usedAt;
        merged.usedForEventId =
          String(claim.usedForEventId || "").trim() ||
          String(current.usedForEventId || "").trim() ||
          String(claim.lastUsedForEventId || "").trim() ||
          String(current.lastUsedForEventId || "").trim() ||
          merged.usedForEventId ||
          null;
      }

      out[claimId] = merged;
    });
  });

  return out;
};
